const LoginPage = () => import ('./index.vue')
const PasswordResetPage = () => import ('./_components/password_reset.vue')
const PasswordOtp = () => import ('./_components/password_otp.vue')
const VIPLoginPage = () => import ('./vip_index.vue')

export default [
    {
        path: '/login/vip_sonko/:type',
        component: VIPLoginPage,
        name: 'VIPLoginIndex'
    },
    {
        path: '/login/:status/:type',
        component: LoginPage,
        name: 'LoginIndex'
    },
    {
        path: '/password/reset/:status',
        component: PasswordResetPage,
        name: 'PasswordResetIndex'
    },
    {
        path: '/password/otp/:account/:phone',
        component: PasswordOtp,
        name: 'PasswordOtpIndex'
    },
]